var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-expanded-plus';
                    var viewUrl = 'gfx/sprite.svg#view-icon-expanded-plus';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 18 18',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };